
import MessageTime from "../../../assets/filled/MessageTime.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function MessageTimeIcon({ className, dataTestid = "MessageTimeIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <MessageTime data-testid={dataTestid} className={classes} {...rest} />
  );
}
